import React from 'react';
import PropTypes from 'prop-types';
import {Box, IconButton, Tooltip, Typography} from '@mui/material';
import AiStarIcon from '../../assets/ai-star-white.svg';
import {TEAL_PRIMARY} from '../../theme';

const floatingButtonStyles = {
  container: {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 999,
  },
  button: {
    width: 48,
    height: 48,
    backgroundColor: '#FFFFFF',
    border: '1px solid #DDE0DE',
    borderRadius: '50%',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: TEAL_PRIMARY,
      transform: 'scale(1.1)',
      boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.2)',
    },
    transition: 'all 0.2s ease',
  },
};

const AIAssistantFloatingButton = ({isVisible, onClick, isOpen = false}) => {
  return (
    <Box
      sx={{
        ...floatingButtonStyles.container,
        opacity: isVisible && !isOpen ? 1 : 0,
        pointerEvents: isVisible && !isOpen ? 'auto' : 'none',
        visibility: isOpen ? 'hidden' : 'visible',
        transition: 'opacity 0.2s ease, right 0.3s ease',
        right: '24px',
      }}
    >
      <Tooltip
        enterDelay={300}
        title={
          <Typography sx={{p: '5px'}} fontSize={14}>
            {isOpen ? 'Close AI assistant' : 'Open AI assistant'}
          </Typography>
        }
        placement="left"
        componentsProps={{
          tooltip: {
            sx: {
              borderRadius: '4px',
              backgroundColor: '#27353A',
              py: 0,
              px: 0.2,
            },
          },
        }}
      >
        <IconButton
          onClick={onClick}
          sx={{
            ...floatingButtonStyles.button,
            backgroundColor: TEAL_PRIMARY,
          }}
        >
          <img src={AiStarIcon} width={16} height={16} alt="AI Assistant" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

AIAssistantFloatingButton.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

export default AIAssistantFloatingButton;
